import { SerializableObjectSchema } from '../../../../../objects/generic/serialization/serializable-object-schema';
import { CommunicationsRequestName } from '../../../communications-request-name';
import { CommunicationsResponse } from '../../generic/communications-response/communications-response';
import { CommunicationsResponseSchema } from '../../generic/communications-response/communications-response-schema';

import { CommunicationsResponseConferenceParticipantCreateConstructor } from './communications-response-conference-participant-create-constructor';
import { CommunicationsResponseConferenceParticipantCreateError } from './communications-response-conference-participant-create-error';
import { CommunicationsResponseConferenceParticipantCreateSchema } from './communications-response-conference-participant-create-schema';

export class CommunicationsResponseConferenceParticipantCreate extends CommunicationsResponse<CommunicationsResponseConferenceParticipantCreateError> {
  /////////////////////////////////////////////////////////////////////////////
  // Variables
  /////////////////////////////////////////////////////////////////////////////

  /////////////////////////////////////////////////////////////////////////////
  // Constructor
  /////////////////////////////////////////////////////////////////////////////

  constructor(parameters: CommunicationsResponseConferenceParticipantCreateConstructor) {
    super({
      ...parameters,
      [CommunicationsResponseSchema.type]: CommunicationsRequestName.conferenceParticipantCreate,
    });
  }

  /////////////////////////////////////////////////////////////////////////////
  // Deserialize
  /////////////////////////////////////////////////////////////////////////////

  /**
   * This static function is private, and meant to be called only by
   * SerializableObject, and subclasses
   *
   * @param validationResult
   */
  protected static _deserialize(
    validationResult: import('joi').ValidationResult,
  ): CommunicationsResponseConferenceParticipantCreate {
    return new CommunicationsResponseConferenceParticipantCreate(super._deserialize(validationResult));
  }

  /////////////////////////////////////////////////////////////////////////////
  // Serialize
  /////////////////////////////////////////////////////////////////////////////

  public serialize() {
    return super.serialize(CommunicationsResponseConferenceParticipantCreate.getSchema());
  }

  /////////////////////////////////////////////////////////////////////////////
  // Schema
  /////////////////////////////////////////////////////////////////////////////

  public static getSchema(): SerializableObjectSchema {
    return new CommunicationsResponseConferenceParticipantCreateSchema();
  }
}
